// These are global variables in the "design.tpl" file, make sure they are in sync
declare const __cartId: number;
declare const __cartReference: string;
declare const __productId: number;
declare const __customerId: number;
declare const __taxRate: number;
declare const __shopId: number;
declare const __virtualUri: string;
declare const __shopURL: string;
declare const __shopName: string;
declare let __productName: string;
declare let __savedTimestamp: number;
declare let __orderURL: string;
declare let __cartURL: string;

class PrestaGlobals {
    static get cartId(): number { return __cartId; }
    static get cartReference(): string { return __cartReference; }
    static get productId(): number { return __productId; }
    static get customerId(): number { return __customerId; }
    static get taxRate(): number { return __taxRate; }
    static get shopId(): number { return __shopId; }
    static get virtualUri(): string { return __virtualUri; }
    static get shopURL(): string { return __shopURL; }
    static get shopName(): string { return __shopName; }
    static get productName(): string { return __productName; }
    static set productName(name) { __productName = name; }
    static get savedTimestamp(): number { return __savedTimestamp; }
    static set savedTimestamp(timestamp) { __savedTimestamp = timestamp; }
    static get orderURL(): string { return __orderURL; }
    static set orderURL(url) { __orderURL = url; }
    static get cartURL(): string { return __cartURL; }
    static set cartURL(url) { __cartURL = url; }
}

export default PrestaGlobals;
